export const gitCommit = 'c1dce8bf'
